/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type {CoreCompany, CoreUser} from "@mm-products/java-multima-framework";
import type {TaxAccountantDto} from "./TaxAccountantDto";
import { TaxDocumentDto } from "./TaxDocumentDto";
import approvalType = TaxDocumentDto.approvalType;

export type TaxClientDto = {
    readonly _permissions?: Array<string>;
    accountant?: TaxAccountantDto;
    avatar?: string;
    color?: string;
    company?: CoreCompany;
    correctionSince?: string;
    correctionUntil?: string;
    created?: string;
    creator?: string;
    creatorId?: string;
    extractedDocuments?: number;
    period?: TaxClientDto.period;
    unitPath?: string;
    user?: CoreUser;
    valid?: boolean;
    approvalType?: approvalType;
    id?: string;
    modified?: string;
    modifier?: string;
    modifierId?: string;
    name?: string;
    note?: string;
    originalCreator?: string;
    originalCreatorId?: string;
    originalModifier?: string;
    originalModifierId?: string;
    useContract?: boolean;
    useActivity?: boolean;
    useCentre?: boolean;
    useAsDefault?: boolean;
};

export namespace TaxClientDto {
    export enum period {
        MONTH = "MONTH",
        QUARTER = "QUARTER",
    }
}
